import React, { useState } from "react";
import SortBySection from "./Settings/Sort_fillter_option";
import FilterSection from "./Settings/Fillters";
import TechnicalIndicatorSection from "./Settings/TechnicalInd";

function Screener_settings({
  onSortChange,
  onFilterChange,
  onIndicatorChange,
}) {
  const [selectedSortCriterion, setSelectedSortCriterion] = useState("marketCap");
  const [filters, setFilters] = useState({
    strongBuy: "",
    buy: "",
    volume: "",
    newsKeyword: "",
    undervalued: false,
    rank: "",
  });
  const [selectedIndicators, setSelectedIndicators] = useState({
    hourly: [],
    daily: [],
  });

  // Handle sort change
  const handleSortChange = (newSort) => {
    setSelectedSortCriterion(newSort);
    onSortChange(newSort);
  };

  // Handle filter change
  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
    onFilterChange(newFilters);
  };

  // Handle indicator change
  const handleIndicatorChange = (interval, indicators) => {
    setSelectedIndicators((prev) => ({
      ...prev,
      [interval]: indicators,
    }));
    // Pass the updated indicators directly (no need for an updater function)
    onIndicatorChange(interval, indicators);
  };

  return (
    <div>
      <SortBySection onSortChange={handleSortChange} />
      <FilterSection onFilterChange={handleFilterChange} />
      <TechnicalIndicatorSection onIndicatorChange={handleIndicatorChange} />
    </div>
  );
}

export default Screener_settings;
